import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { isAuthSessionValid } from '../utils/tokenUtils';
import { isPublicTutorialFileUnlocked } from '../utils/tutorialsManifest';

/**
 * Javna stranica za direktan URL /tuts/ime.mp4 — ne sme pasti na /:companySlug/* (login).
 * Ostali snimci osim prvog (video1.mp4) zahtevaju registraciju.
 */
const TutsPlayer = () => {
  const { '*': rest } = useParams();
  const safe = rest ? String(rest).replace(/^\//, '').replace(/\.\./g, '') : '';
  const unlocked = isPublicTutorialFileUnlocked(safe, isAuthSessionValid());
  const src = safe && unlocked ? `/tuts/${safe}` : '';

  return (
    <div className="min-h-screen bg-gray-900 flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-4xl">
        <Link to="/tutorials" className="text-green-400 hover:text-green-300 mb-4 inline-block text-sm font-medium">
          ← Nazad na tutorijale
        </Link>
        {src ? (
          <video
            key={src}
            controls
            playsInline
            preload="metadata"
            className="w-full rounded-lg bg-black max-h-[min(85vh,720px)]"
            src={src}
          >
            Tvoj pregledač ne podržava video.
          </video>
        ) : safe && !unlocked ? (
          <div className="rounded-lg border border-amber-400/40 bg-gray-800 p-6 text-gray-100">
            <p className="font-medium">Ovaj tutorijal je dostupan nakon prijave.</p>
            <Link
              to="/auth?role=company&type=login"
              className="mt-4 inline-flex rounded-lg bg-green-600 px-4 py-2 text-sm font-semibold text-white hover:bg-green-700"
            >
              Prijavi se
            </Link>
          </div>
        ) : (
          <p className="text-gray-300">Nepoznata putanja fajla.</p>
        )}
      </div>
    </div>
  );
};

export default TutsPlayer;
